export default "__VITE_ASSET__D0vW8VFM__"